import { globalGetService } from '@/utils/globalApiServices';
import { Dca } from './types';

export const getDcas = async () => {
  const response = await globalGetService('csp/dca', {
    recordsPerPage: 1000,
  });
  return (response?.ok ? response.data.records : []) as Dca[];
};
